import { v4 as uuid } from 'uuid';

export class uniProfession {

  static END_POINT = "uni_profession";

  serno = 0;
  guid;//= uuid();

  professionName = "";
  professionCode = "";

  constructor() {
    this.guid = uuid();
  }


}